import React, { useEffect, useState } from 'react';
import { api } from '../api';
import KontaktForm from '../components/KontaktForm';

export default function KundenListe({ navigate }) {
  const [kunden, setKunden] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editKunde, setEditKunde] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    api.getKunden()
      .then(setKunden)
      .catch(() => setError('Fehler beim Laden der Kunden'))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleSave = () => {
    setShowForm(false);
    setEditKunde(null);
    load();
  };

  const handleDelete = async () => {
    try {
      await api.deleteKunde(deleteId);
      setDeleteId(null);
      load();
    } catch (e) {
      alert(e.message);
      setDeleteId(null);
    }
  };

  const filtered = kunden.filter(k =>
    k.name.toLowerCase().includes(search.toLowerCase()) ||
    (k.ort || '').toLowerCase().includes(search.toLowerCase()) ||
    (k.email || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Kunden</div>
          <div className="page-subtitle">{kunden.length} Kunden gesamt</div>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <div className="search-bar">
            <input
              className="form-input"
              placeholder="Suchen…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <button className="btn btn-primary" onClick={() => { setEditKunde(null); setShowForm(true); }}>
            + Neuer Kunde
          </button>
        </div>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="spinner">Lade Kunden…</div>
      ) : filtered.length === 0 ? (
        <div className="card">
          <div className="card-body empty-state">
            <div className="empty-state-icon">👤</div>
            <div className="empty-state-title">{search ? 'Keine Treffer' : 'Noch keine Kunden'}</div>
            <div className="empty-state-desc">
              {search ? 'Suchbegriff anpassen.' : 'Legen Sie Ihren ersten Kunden an.'}
            </div>
          </div>
        </div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Adresse</th>
                <th>Telefon</th>
                <th>E-Mail</th>
                <th>Fahrzeuge</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(k => (
                <tr key={k.id}>
                  <td>
                    <strong
                      style={{ cursor: 'pointer', color: 'var(--primary)' }}
                      onClick={() => navigate('kunde-detail', { kundenId: k.id })}
                    >
                      {k.name}
                    </strong>
                  </td>
                  <td>{[k.strasse, k.plz, k.ort].filter(Boolean).join(', ') || '–'}</td>
                  <td>{k.telefon || '–'}</td>
                  <td>{k.email || '–'}</td>
                  <td>
                    <span className="badge badge-blue">{k.fahrzeug_anzahl || 0}</span>
                  </td>
                  <td>
                    <div className="td-actions">
                      <button
                        className="btn btn-ghost btn-sm"
                        onClick={() => navigate('kunde-detail', { kundenId: k.id })}
                      >
                        Fahrzeuge
                      </button>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() => { setEditKunde(k); setShowForm(true); }}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => setDeleteId(k.id)}
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <KontaktForm
          initial={editKunde}
          defaultTyp="Kunde"
          onSave={handleSave}
          onClose={() => { setShowForm(false); setEditKunde(null); }}
        />
      )}

      {deleteId && (
        <div className="modal-overlay" onClick={() => setDeleteId(null)}>
          <div className="modal" style={{ maxWidth: 400 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">Kunde löschen</span>
              <button className="modal-close" onClick={() => setDeleteId(null)}>✕</button>
            </div>
            <div className="modal-body confirm-dialog">
              <p>Möchten Sie diesen Kunden wirklich löschen?<br />Alle zugehörigen Fahrzeuge werden ebenfalls gelöscht.</p>
              <div className="confirm-actions">
                <button className="btn btn-secondary" onClick={() => setDeleteId(null)}>Abbrechen</button>
                <button className="btn btn-danger" onClick={handleDelete}>Löschen</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
